export enum EZasadyVyplaty {
    VYNO = 'VYNO',
    RUST = 'RUST',
    SMIS = 'SMIS'
}
